import {AfterViewInit, Directive, ElementRef, Input, OnDestroy, Renderer2} from '@angular/core';
import ResizeObserver from "resize-observer-polyfill";

@Directive({
  selector: '[smartTableCollapseSticky]'
})
export class SmartTableCollapseStickyDirective implements AfterViewInit, OnDestroy {

  @Input('smartTableCollapseSticky') content: Element;

  resize: {
    listen: any,
    element: Element
  };

  constructor(private elementRef: ElementRef,
              private renderer: Renderer2) { }

  ngAfterViewInit() {
    this.update();
  }

  ngOnDestroy() {
    this.resize.listen.unobserve(this.resize.element);
    this.resize.listen.disconnect();
  }

  update() {
    const table = this.content.querySelector('table');

    const resize = new ResizeObserver((entries, observer) => {
      const width = (entries[0].target as any).offsetWidth;
      const tableWidth = table.offsetWidth;
      const contentOffsetLeft = entries[0].target.getBoundingClientRect().left;
      const tableOffsetLeft = table.getBoundingClientRect().left;
      const padding = tableOffsetLeft - contentOffsetLeft;

      if (tableWidth + padding * 2 === width) return;

      const result = width - padding;

      this.renderer.setStyle(this.elementRef.nativeElement, 'width', `${result}px`);
      this.renderer.setStyle(this.elementRef.nativeElement, 'left', `${padding / 2}px`);
    });

    resize.observe(this.content);

    this.resize = {
      listen: resize,
      element: this.content
    }
  }
}
